<template>
	<label>
		<input
			v-model.trim="value"
			v-on:blur="eventBlur"
			v-on:focus="eventFocus"
			:value="sman"
			:name="refs"
			type="radio"
			:placeholder="item.placeholder"
			v-bind:style="colorBorder"
		/>
	</label>
</template>

<script>
  import DataForInput from '@/store/Form/longFormOptions';
  import {mapGetters, mapState} from 'vuex'


  export default {
    inheritAttrs: false,
    name: "abtRadio",
    data: function () {
      return {
        item: DataForInput[this.refs],
        isTimeToShowError:false
      }
    },
    props: {
      sman: {
		type: String,
		default: ''
		},
      refs: {
        type: String,
        default: 'null'
      },
    },
    methods: {
      eventBlur: function () {
        this.$palantir.trackInputBlur(this.refs,this.valueVuex[this.refs]);
        this.$store.dispatch('errorShow', {
          target: this.refs,
          value: true,
        });
      },
      eventFocus: function(){
        this.$palantir.trackInputFocus(this.refs);
        this.$store.dispatch('errorShow', {
          target: this.refs,
          value: false,
        });
      }
    },
    watch: {

    },
    mounted() {
		//console.log(this.valueVuex[this.refs].value);
    },
    computed: {
      status :function(){
        return this.statusVuex[this.refs].code;
      },
      errorMsg :function(){
        return this.statusVuex[this.refs].msg;
      },
      showErrorMessage:function(){
        return this.status != 0 && this.isTimeToShowError;
      },
      colorBorder: function () { return false;},
      value:{
        get(){
          return this.valueVuex[this.refs]
        },
        set(value){
          let utiputi = {
            target:this.refs,
            value: value
          };
          this.$store.dispatch('saveSendData',utiputi);
        }
      },
      errorStatus:function () {
        return false
      },
      ...mapGetters(['getTargetFieldValue']),
      ...mapState({
        valueVuex: state => state.Form.sendData,
        statusVuex: state => state.Form.workData
      })
    }

  }
</script>

<style scoped>
input[type=radio] {
  border: .1rem solid #D5D5D5;
  appearance: none;
  margin-left: 1rem;
  display: flex;
  align-items: center;
  justify-content: space-around;
  font-size: .8rem;
}
input[value=M]::before {
  content: 'М';
}
input[value=W]::before {
  content: 'Ж';
}
input[type=radio]:checked {
  border: .1rem solid #262323;
}
input[type=radio] {
  width: 1.7rem;
  height: 1.7rem;
  border-radius: 0.3rem;
}
@media (min-width: 768px) {
  input[type=radio] {
    width: 2.7rem;
    height: 2.7rem;
    border-radius: 0.6rem;
  }
}
</style>
